import discordService from './discordService';
import { functionsBase } from '../config/functionsBase';

const FUNCTIONS_BASE = functionsBase('/.netlify/functions');

async function economyFetch(path, options = {}) {
  const token = discordService.getPlayerAccessToken();
  if (!token) {
    const err = new Error(
      'Sessão Discord expirada ou incompleta. Conecte novamente para usar o Nexus Pay.'
    );
    err.code = 'NO_TOKEN';
    throw err;
  }

  const res = await fetch(`${FUNCTIONS_BASE}/${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(options.headers || {}),
    },
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.error || `Erro ${res.status}`);
    err.status = res.status;
    err.data = data;
    err.code =
      data.code ||
      (res.status === 401
        ? 'UNAUTHORIZED'
        : res.status === 429
          ? 'cooldown'
          : 'API');
    throw err;
  }
  return data;
}

export function fetchEconomyWallet() {
  return economyFetch('economy-wallet', { method: 'GET' });
}

export function economyAction(action, payload = {}) {
  return economyFetch('economy-action', {
    method: 'POST',
    body: JSON.stringify({ action, ...payload }),
  });
}

export function claimDaily() {
  return economyAction('daily');
}

export function claimWork() {
  return economyAction('work');
}

export function playCoinflip(amount, choice) {
  return economyAction('coinflip', { amount, choice });
}

export function playDice(amount) {
  return economyAction('dice', { amount });
}

export function playSlots(amount) {
  return economyAction('slots', { amount });
}

export const TX_LABELS = {
  daily: 'Daily',
  work: 'Trabalho',
  game_bet: 'Aposta',
  game_win: 'Prêmio',
  game_tie: 'Empate',
  pay_in: 'Recebido',
  pay_out: 'Enviado',
  pay_refund: 'Estorno',
  credit: 'Crédito',
  debit: 'Débito',
  admin_set: 'Ajuste',
  bridge_in: 'Câmbio (entrada)',
  bridge_out: 'Câmbio (saída)',
};

export default {
  fetchEconomyWallet,
  economyAction,
  claimDaily,
  claimWork,
  playCoinflip,
  playDice,
  playSlots,
  TX_LABELS,
};
